import { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';

const AGENT_PASSWORD = "delrn2024";

export default function AgentLogin({ onLogin }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!phone || !password) {
      setError('Enter phone and password');
      return;
    }
    if (password !== AGENT_PASSWORD) {
      setError('Wrong password. Contact admin.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const fullPhone = phone.startsWith('+') ? phone : '+91' + phone;
      const q = query(
        collection(db, 'agents'),
        where('phone', '==', fullPhone)
      );
      const snap = await getDocs(q);
      if (snap.empty) {
        setError('You are not registered. Contact admin.');
        setLoading(false);
        return;
      }
      onLogin(snap.docs[0].id);
    } catch (e) {
      setError('Login failed. Try again.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.emoji}>🎓</div>
        <h1 style={styles.title}>Agent Login</h1>
        <p style={styles.subtitle}>MalluGermanTalk Sprachpartner</p>

        <div style={styles.inputRow}>
          <span style={styles.prefix}>+91</span>
          <input
            style={styles.input}
            type="tel"
            placeholder="Phone number"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
        </div>

        <input
          style={styles.passwordInput}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button
          style={styles.button}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>

        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#0f0f1a',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    backgroundColor: '#1e1e30',
    borderRadius: '20px',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  emoji: { fontSize: '60px', marginBottom: '12px' },
  title: { color: '#ffffff', fontSize: '24px', fontWeight: '900', margin: '0 0 8px 0' },
  subtitle: { color: '#ffffff60', fontSize: '14px', margin: '0 0 32px 0' },
  inputRow: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#0f0f1a',
    borderRadius: '12px',
    padding: '0 16px',
    marginBottom: '12px',
  },
  prefix: { color: '#ffffff60', fontSize: '16px', marginRight: '8px' },
  input: {
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    color: '#ffffff',
    fontSize: '18px',
    padding: '14px 0',
    outline: 'none',
    width: '100%',
  },
  passwordInput: {
    width: '100%',
    backgroundColor: '#0f0f1a',
    border: 'none',
    borderRadius: '12px',
    color: '#ffffff',
    fontSize: '16px',
    padding: '14px',
    marginBottom: '12px',
    outline: 'none',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    backgroundColor: '#f97316',
    color: '#ffffff',
    border: 'none',
    borderRadius: '12px',
    padding: '16px',
    fontSize: '16px',
    fontWeight: '800',
    cursor: 'pointer',
    marginTop: '8px',
  },
  error: { color: '#ef4444', fontSize: '13px', marginTop: '12px' },
};